import Vue from 'vue'
import Router from 'vue-router'
import App from '@/pages/App'
const Software = () => import('@/pages/Software')
const Material = () => import('@/pages/Material')
const Share = () => import('@/pages/Share')
const Tools = () => import('@/pages/Tools')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: App
    },
    {
      path: '/index.html',
      name: 'IndexHtml',
      component: App
    },
    {
      path: '/app.html',
      name: 'AppHtml',
      component: App
    },
    {
      path: '/software.html',
      name: 'SoftwareHtml',
      component: Software
    },
    {
      path: '/material.html',
      name: 'MaterialHtml',
      component: Material
    },
    {
      path: '/share.html',
      name: 'ShareHtml',
      component: Share
    },
    {
      path: '/tools.html',
      name: 'ToolsHtml',
      component: Tools
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js